/**
 *
 */
import Vue from 'vue'
import VueJsonp from 'vue-jsonp'

Vue.use(VueJsonp)

export default Vue.prototype.$jsonp
